import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "ladyart_cookie_consent";

export default function CookieConsent() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        let stored = null;
        try {
            stored = localStorage.getItem(KEY);
        } catch (e) {
            stored = null;
        }
        if (!stored) {
            const t = setTimeout(() => setShow(true), 1200);
            return () => clearTimeout(t);
        }
    }, []);

    const accept = () => {
        try {
            localStorage.setItem(KEY, "accepted");
        } catch (e) {
            /* ignore */
        }
        setShow(false);
    };

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    data-testid="cookie-consent"
                    initial={{ opacity: 0, y: 28 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 28 }}
                    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-5 left-5 right-5 z-[60] md:left-8 md:right-auto md:max-w-md"
                >
                    <div
                        className="p-7 md:p-8"
                        style={{
                            backgroundColor: "var(--bg)",
                            border: "1px solid var(--line)",
                        }}
                    >
                        <span className="eyebrow">Cookie-uri</span>
                        <p
                            className="mt-4 font-sans text-sm"
                            style={{
                                color: "var(--muted-foreground)",
                                lineHeight: 1.75,
                            }}
                        >
                            Folosim doar cookie-uri tehnice, necesare funcționării
                            site-ului. Continuând navigarea, ești de acord cu
                            utilizarea acestora.
                        </p>
                        <div className="mt-7 flex items-center gap-7">
                            <button
                                type="button"
                                data-testid="cookie-accept"
                                onClick={accept}
                                className="pill px-8 py-3 font-sans"
                                style={{
                                    backgroundColor: "var(--ink)",
                                    color: "var(--bg)",
                                    fontSize: "0.72rem",
                                    letterSpacing: "0.18em",
                                    textTransform: "uppercase",
                                }}
                                onMouseEnter={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                        "var(--accent)")
                                }
                                onMouseLeave={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                        "var(--ink)")
                                }
                            >
                                Accept
                            </button>
                            <Link
                                to="/politica-cookies"
                                data-testid="cookie-details"
                                className="eyebrow eyebrow-ink link-underline"
                            >
                                Detalii
                            </Link>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
